import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { API_URL } from '../../utils/constant';
// Fetch all taxes
export const fetchTaxes = createAsyncThunk('taxes/fetchTaxes', async (id) => {
    const response = await axios.get(`${API_URL}/accounting/taxes/${id}`);
    // console.log(response);
    return response.data;
});

// Create a new tax
export const createTax = createAsyncThunk('taxes/createTax', async (taxData) => {
    const company = JSON.parse(localStorage.getItem('company'));
    const response = await axios.post(`${API_URL}/accounting/taxes`, {
        company_id: company.company?.id,
        name: taxData.name,
        rate: taxData.rate,
    });
    return response.data;
});

// Update an existing tax
export const updateTax = createAsyncThunk('taxes/updateTax', async ({ id, taxData }) => {
    const response = await axios.put(`${API_URL}/accounting/taxes/${id}`, taxData);
    return response.data;
});

// Delete a tax
export const deleteTax = createAsyncThunk('taxes/deleteTax', async (id) => {
    await axios.delete(`${API_URL}/accounting/taxes/${id}`);
    return id;
});

// Initial State
const initialState = {
    taxes: [],
    loading: false,
    error: null
};

export const taxesSlice = createSlice({
    name: 'taxes',
    initialState,
    reducers: {},

    extraReducers: (builder) => {
        builder
            // Fetch taxes
            .addCase(fetchTaxes.pending, (state) => {
                state.loading = true;
            })
            .addCase(fetchTaxes.fulfilled, (state, action) => {
                state.loading = false;
                state.taxes = action.payload.data;
            })
            .addCase(fetchTaxes.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            })

            // Create tax
            .addCase(createTax.fulfilled, (state, action) => {
                state.taxes.push(action.payload.data);
            })

            // Update tax
            .addCase(updateTax.fulfilled, (state, action) => {
                const index = state.taxes.findIndex(tax => tax.id === action.payload.data.id);
                if (index != -1) {
                    state.taxes[index] = action.payload.data;
                }
            })

            // Delete tax
            .addCase(deleteTax.fulfilled, (state, action) => {
                state.taxes = state.taxes.filter(tax => tax.id !== action.payload);
            });
    }
});

export default taxesSlice.reducer;
